import * as React from 'react'
import { withPrefix } from 'gatsby'
import Blocks from '@dfb/gatsby-dfb-theme/src/components/blocks'
import MHeroBlank from '@dfb/gatsby-dfb-theme/src/components/blocks/m_hero_blank'
import MRichtext from '@dfb/gatsby-dfb-theme/src/components/blocks/m_richtext'
import SEO from '@dfb/gatsby-dfb-theme/src/components/modules/seo'
import { t } from '@dfb/gatsby-dfb-theme/src/i18n-utility'
import MCardGridTopic from '@dfb/gatsby-dfb-theme/src/components/blocks/m_card_grid_topic'
import { useGetNewsImage, getNewsFallbackImageUrl } from '@dfb/gatsby-dfb-theme/src/hooks/useNewsFallbackImage'
import { useLanguage } from '@dfb/gatsby-dfb-theme/src/hooks/useLanguage'
import MImage from '../blocks/m_image'
import Layout from '../layout'

const NewsPage = (props) => {
  const language = useLanguage()
  const isMigratedNews = !!props.content.tx_headless_news_text && !props.content.body.length
  const getNewsImage = useGetNewsImage(props.page.brand)

  const newsDateValue = props.page.tx_headless_news_date || props.page.starttime || props.page.published_at || props.page.created_at

  const articleData = {
    author: props.page.author || 'DFB',
    body: isMigratedNews ? props.content.tx_headless_news_text : props.content.body,
    date: newsDateValue ? new Date(newsDateValue) : undefined,
    image: getNewsImage(props),
    metaOgDescription: props.metadata.ogdescription,
    metaDescription: props.metadata.description,
    metaTitle: props.metadata.title,
    metaKeywords: props.metadata.keywords,
    metaOgImage: props.metadata.ogimage?.src || getNewsFallbackImageUrl(props.page.brand),
    metaOgTitle: props.metadata.ogtitle,
    overline: props.content.main_category?.title,
    related: props.content.related,
    subline: props.content.subtitle,
    title: props.content.title,
    url: process.env.PUBLIC_CDN_HOST + withPrefix(props.page.full_slug),
  }

  // Get titles from categories
  const categoryTitles = props.content.categories
    .map((category) => category?.title)
    .filter((title) => title)
    .join(', ')

  return (
    <Layout
      accessGroups={props.accessGroups}
      brand={props.page.brand}
      pageType="news"
      pageUid={props.page.uid}
      translations={props.translations}
      language={language}
    >
      <SEO
        pagetitle={articleData.title}
        title={articleData.metaTitle}
        description={articleData.metaDescription}
        keywords={props.metadata?.keywords?.split(',')}
        ogtitle={articleData.metaOgTitle}
        ogdescription={articleData.metaOgDescription}
        ogimage={articleData.metaOgImage}
        noindex={props.metadata.noindex ? props.metadata.noindex : 0}
      />

      <main className="l-Main" role="main">
        <MHeroBlank
          data={{
            date: articleData.date,
            headline: articleData.title,
            image: { src: '', alt: '' },
            overline: articleData.overline,
            subline: articleData.subline,
          }}
        />

        <MImage data={{ image: [articleData.image] }} />

        {isMigratedNews && <MRichtext data={{ text: articleData.body }} />}

        {articleData.body &&
          articleData.body.map &&
          articleData.body.map((block) =>
            Blocks[block.component]
              ? React.createElement(Blocks[block.component], {
                  key: block.uid,
                  data: {
                    ...block,
                    root_categories: props.content.root_categories,
                  },
                  pageData: {},
                })
              : `Block ${block.component} in ${block.uid} not created yet`
          )}

        <MRichtext
          data={{
            text: `
              <p>
                <b>${t(props.translations, 'news_page.categories')}:</b>
                ${categoryTitles}
              </p>
              <p>
                <b>${t(props.translations, 'news_page.author')}:</b>
                ${articleData.author}
              </p>
            `,
            space_before_class: 'large',
            space_after_class: 'extra-large',
          }}
        />

        {articleData.related && articleData.related.length > 0 && (
          <MCardGridTopic
            data={{
              headline: t(props.translations, 'news_page.related'),
              link_text: t(props.translations, 'news_page.related_button_label'),
              collection: props.content.related,
            }}
          />
        )}
      </main>
    </Layout>
  )
}

export default NewsPage
